"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathWithQuery = exports.getFirstQueryValue = exports.getQueryBooleanValue = exports.getQueryNumericValue = exports.getQueryValue = void 0;
function getQueryValue(value) {
    return value ? String(value) : undefined;
}
exports.getQueryValue = getQueryValue;
function getQueryNumericValue(value) {
    return value ? Number(value) : undefined;
}
exports.getQueryNumericValue = getQueryNumericValue;
function getQueryBooleanValue(value) {
    if (value) {
        const strValue = String(value).toLowerCase();
        return ["true", "t", "1"].includes(strValue);
    }
    return undefined;
}
exports.getQueryBooleanValue = getQueryBooleanValue;
function getFirstQueryValue(value) {
    const newValue = Array.isArray(value) ? value[0] : value;
    return newValue !== null && newValue !== void 0 ? newValue : undefined;
}
exports.getFirstQueryValue = getFirstQueryValue;
function getPathWithQuery(originalPath, query) {
    let path = originalPath;
    if (query && Object.keys(query).length) {
        let separator = path.includes("?") ? "&" : "?";
        Object.entries(query).forEach(([key, value]) => {
            if (value || value === 0) {
                path = `${path}${separator}${key}=${value}`;
                separator = "&";
            }
        });
    }
    return encodeURI(path);
}
exports.getPathWithQuery = getPathWithQuery;
//# sourceMappingURL=index.js.map